<!-- PANE 4 -->
<div class="pane4">
  <mat-toolbar class="pane-header">
    <!-- Back button - only visible on mobile -->
    <button *ngIf="isMobileView"
            mat-icon-button
            class="mobile-back-button"
            (click)="goBackToMain()"
            matTooltip="Back to Questions">
      <mat-icon>arrow_back</mat-icon>
    </button>

    <span>DETAILS</span>
    <span class="spacer"></span>
    <!-- Show mains checkbox - only visible when in fullscreen mode -->
    <mat-checkbox *ngIf="isFullscreenMode"
                 [(ngModel)]="showMains"
                 (change)="onShowMainsChange()"
                 color="primary"
                 class="show-mains-checkbox">
      Show Main Area
    </mat-checkbox>
  </mat-toolbar>
  <mat-divider></mat-divider>
  <div class="pane-content">
    <mat-toolbar color="transparent" class="sub-header">
      <span>RESULTS</span>
      <span class="spacer"></span>
      <mat-checkbox [(ngModel)]="showQuestion" color="primary">SHOW QUESTION ALSO</mat-checkbox>
      <mat-checkbox [(ngModel)]="showHindi" color="primary" class="hindi-checkbox">SHOW HINDI</mat-checkbox>

      <!-- View Mode Button -->
      <button mat-icon-button
              [matMenuTriggerFor]="viewMenu"
              matTooltip="Change View Mode"
              class="view-mode-button">
        <mat-icon>{{ getViewModeIcon() }}</mat-icon>
      </button>

      <!-- View Mode Menu -->
      <mat-menu #viewMenu="matMenu">
        <!-- Layout toggle option -->
        <div class="layout-toggle-container" mat-menu-item (click)="$event.stopPropagation()">
          <span>View Layout:</span>
          <div class="toggle-with-label">
            <span class="toggle-label" [class.active-label]="viewMenuLayoutDirection === 'vertical'">Vertical</span>
            <mat-slide-toggle
              color="primary"
              [checked]="viewMenuLayoutDirection === 'horizontal'"
              (change)="toggleViewMenuLayout($event)">
            </mat-slide-toggle>
            <span class="toggle-label" [class.active-label]="viewMenuLayoutDirection === 'horizontal'">Horizontal</span>
          </div>
        </div>
        <mat-divider></mat-divider>

        <!-- View mode options - rendered based on layout direction -->
        <div [ngClass]="{'horizontal-layout': viewMenuLayoutDirection === 'horizontal'}">
          <button mat-menu-item
                  [disabled]="viewMode === 'split'"
                  (click)="setViewMode('split')"
                  [class.selected-menu-item]="viewMode === 'split'">
            <mat-icon>view_column</mat-icon>
            <span>Side-Pane</span>
          </button>
          <button mat-menu-item
                  [disabled]="viewMode === 'fullscreen'"
                  (click)="setViewMode('fullscreen')"
                  [class.selected-menu-item]="viewMode === 'fullscreen'">
            <mat-icon>fullscreen</mat-icon>
            <span>Full-Screen</span>
          </button>
        </div>
      </mat-menu>

      <!-- Close Window Button -->
      <button mat-icon-button
              (click)="closeDetailsArea()"
              matTooltip="Close Details"
              class="close-window-button">
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
    <ng-container *ngIf="selectedCard; else noSelection">
      <!-- Standard View (Without Hindi) -->
      <div class="content-wrapper" *ngIf="!showHindi">
        <!-- Question Section (Conditional) - MOVED TO TOP -->
        <ng-container *ngIf="showQuestion">
          <div class="question-section">
            <h4 class="section-title question-title">Question</h4>
            <div class="question-row">
              <div class="question-img-container">
                <img [src]="selectedCard.imageUrl"
                     alt="Question Image"
                     class="question-img"
                     (load)="onQuestionImageLoad()"
                     (error)="onQuestionImageError()">
              </div>
              <div class="question-text-container">
                <p>{{ selectedCard.questionText }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Answer Image and Text -->
        <div class="answer-section">
          <div class="answer-row">
            <div class="answer-img-container">
              <img [src]="selectedCard.answerImageUrl"
                   alt="Answer Image"
                   class="answer-img"
                   (load)="onAnswerImageLoad()"
                   (error)="onAnswerImageError()">
            </div>
            <div class="answer-text-container">
              <h4 class="section-title">Answer</h4>
              <p>{{ selectedCard.answerText }}</p>
            </div>
          </div>
        </div>

        <!-- Explanation Section -->
        <div class="explanation-section">
          <h4 class="section-title explanation-title">Explanation</h4>
          <div class="explanation-row">
            <div class="explanation-img-container">
              <img [src]="selectedCard.explanationImageUrl"
                   alt="Explanation Image"
                   class="explanation-img"
                   (load)="onExplanationImageLoad()"
                   (error)="onExplanationImageError()">
            </div>
            <div class="explanation-text-container">
              <p>{{ selectedCard.explanationText }}</p>
              <!-- OCR Explanation Blocks -->
              <ng-container *ngIf="selectedCard.explanationBlocks && selectedCard.explanationBlocks.length">
                <div class="explanation-blocks">
                  <ng-container *ngFor="let block of selectedCard.explanationBlocks">
                    <p *ngIf="block.type === 'text'" class="expl-text">{{ block.content }}</p>
                    <div *ngIf="block.type === 'table'" class="expl-table-wrap">
                      <table class="expl-table">
                        <thead *ngIf="block.headers && block.headers.length">
                          <tr><th *ngFor="let h of block.headers">{{ h }}</th></tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of block.rows">
                            <td *ngFor="let cell of row">{{ cell }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="block.type === 'figure' && block.imageUrl" class="expl-figure-wrap">
                      <img [src]="block.imageUrl" [alt]="block.content" class="expl-figure-img">
                      <p *ngIf="block.content" class="expl-figure-caption">{{ block.content }}</p>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </div>

      <!-- 4x4 Grid View (With Hindi) -->
      <div class="content-wrapper grid-view" *ngIf="showHindi">
        <h4 class="grid-title">English & Hindi Content</h4>

        <!-- Question Section (Conditional, 2 columns) - MOVED TO TOP -->
        <ng-container *ngIf="showQuestion">
          <div class="section-label">Question</div>
          <div class="grid-4x4-container questions-grid">
            <!-- English Question -->
            <div class="grid-item">
              <h5 class="cell-title">English Question</h5>
              <div class="grid-img-container">
                <img [src]="selectedCard.imageUrl"
                     alt="Question Image"
                     class="grid-img"
                     (load)="onQuestionImageLoad()"
                     (error)="onQuestionImageError()">
              </div>
              <div class="grid-text-container">
                <p>{{ selectedCard.questionText }}</p>
              </div>
            </div>

            <!-- Hindi Question -->
            <div class="grid-item">
              <h5 class="cell-title">Hindi Question</h5>
              <div class="grid-img-container">
                <img [src]="selectedCard.hindiQuestionImageUrl || selectedCard.imageUrl"
                     alt="Hindi Question Image"
                     class="grid-img"
                     (load)="onHindiQuestionImageLoad()"
                     (error)="onHindiQuestionImageError()">
              </div>
              <div class="grid-text-container">
                <p>{{ selectedCard.hindiQuestionText || selectedCard.questionText }}</p>
              </div>
            </div>
          </div>
        </ng-container>

        <!-- Answer Section (2 columns) -->
        <div class="section-label">Answer</div>
        <div class="grid-4x4-container answers-grid">
          <!-- English Answer -->
          <div class="grid-item answer-item">
            <h5 class="cell-title">English Answer</h5>
            <div class="grid-img-container">
              <img [src]="selectedCard.answerImageUrl"
                   alt="Answer Image"
                   class="grid-img"
                   (load)="onAnswerImageLoad()"
                   (error)="onAnswerImageError()">
            </div>
            <div class="grid-text-container">
              <p>{{ selectedCard.answerText }}</p>
            </div>
          </div>

          <!-- Hindi Answer -->
          <div class="grid-item answer-item">
            <h5 class="cell-title">Hindi Answer</h5>
            <div class="grid-img-container">
              <img [src]="selectedCard.hindiAnswerImageUrl || selectedCard.answerImageUrl"
                   alt="Hindi Answer Image"
                   class="grid-img"
                   (load)="onHindiAnswerImageLoad()"
                   (error)="onHindiAnswerImageError()">
            </div>
            <div class="grid-text-container">
              <p>{{ selectedCard.hindiAnswerText || selectedCard.answerText }}</p>
            </div>
          </div>
        </div>

        <!-- Explanation Section (2 columns) -->
        <div class="section-label">Explanation</div>
        <div class="grid-4x4-container explanations-grid">
          <!-- English Explanation -->
          <div class="grid-item">
            <h5 class="cell-title">English Explanation</h5>
            <div class="grid-img-container">
              <img [src]="selectedCard.explanationImageUrl"
                   alt="Explanation Image"
                   class="grid-img"
                   (load)="onExplanationImageLoad()"
                   (error)="onExplanationImageError()">
            </div>
            <div class="grid-text-container">
              <p>{{ selectedCard.explanationText }}</p>
              <!-- OCR Explanation Blocks -->
              <ng-container *ngIf="selectedCard.explanationBlocks && selectedCard.explanationBlocks.length">
                <div class="explanation-blocks">
                  <ng-container *ngFor="let block of selectedCard.explanationBlocks">
                    <p *ngIf="block.type === 'text'" class="expl-text">{{ block.content }}</p>
                    <div *ngIf="block.type === 'table'" class="expl-table-wrap">
                      <table class="expl-table">
                        <thead *ngIf="block.headers && block.headers.length">
                          <tr><th *ngFor="let h of block.headers">{{ h }}</th></tr>
                        </thead>
                        <tbody>
                          <tr *ngFor="let row of block.rows">
                            <td *ngFor="let cell of row">{{ cell }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                    <div *ngIf="block.type === 'figure' && block.imageUrl" class="expl-figure-wrap">
                      <img [src]="block.imageUrl" [alt]="block.content" class="expl-figure-img">
                      <p *ngIf="block.content" class="expl-figure-caption">{{ block.content }}</p>
                    </div>
                  </ng-container>
                </div>
              </ng-container>
            </div>
          </div>

          <!-- Hindi Explanation -->
          <div class="grid-item">
            <h5 class="cell-title">Hindi Explanation</h5>
            <div class="grid-img-container">
              <img [src]="selectedCard.hindiExplanationImageUrl || selectedCard.explanationImageUrl"
                   alt="Hindi Explanation Image"
                   class="grid-img"
                   (load)="onHindiExplanationImageLoad()"
                   (error)="onHindiExplanationImageError()">
            </div>
            <div class="grid-text-container">
              <p>{{ selectedCard.hindiExplanationText || selectedCard.explanationText }}</p>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
    <ng-template #noSelection>
      <div class="no-selection">
        <mat-icon>touch_app</mat-icon>
        <h3>No Question Selected</h3>
        <p>Please click on a question in the main area to view its details here.</p>
      </div>
    </ng-template>

    <!-- OCR'ed Content Section (bottom half) -->
    <ng-container *ngIf="selectedCard">
      <mat-divider class="ocr-divider"></mat-divider>
      <div class="ocr-section">
        <h4 class="ocr-section-title">OCR'ed Content</h4>
        <mat-tab-group [(selectedIndex)]="ocrTabIndex" class="ocr-tabs" mat-stretch-tabs="false">
          <mat-tab label="Tesseract">
            <div class="ocr-tab-content">
              <div class="ocr-text-block" *ngIf="selectedCard.questionText">
                <h5>Question</h5>
                <p>{{ selectedCard.questionText }}</p>
              </div>
              <div class="ocr-text-block" *ngIf="selectedCard.answerText">
                <h5>Answer</h5>
                <p>{{ selectedCard.answerText }}</p>
              </div>
              <div class="ocr-text-block" *ngIf="selectedCard.explanationText">
                <h5>Explanation</h5>
                <p>{{ selectedCard.explanationText }}</p>
              </div>
              <div class="ocr-text-block" *ngIf="selectedCard.hindiQuestionText">
                <h5>Hindi Question</h5>
                <p>{{ selectedCard.hindiQuestionText }}</p>
              </div>
              <p *ngIf="!selectedCard.questionText && !selectedCard.answerText && !selectedCard.explanationText" class="ocr-placeholder">No Tesseract OCR text available.</p>
            </div>
          </mat-tab>
          <mat-tab label="Mistral OCR">
            <div class="ocr-tab-content">
              <p class="ocr-placeholder">Mistral OCR results will appear here.</p>
            </div>
          </mat-tab>
          <mat-tab label="Google OCR">
            <div class="ocr-tab-content">
              <p class="ocr-placeholder">Google Cloud Vision / Document AI results will appear here.</p>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ng-container>
  </div>
  <div class="tab-container" *ngIf="selectedTabIndex > 0">
    <!-- Tab content container - only shown when tab is not "Details" -->
    <div class="tab-content" *ngIf="selectedCard && selectedTabIndex === 1">
      <!-- More-Details tab content -->
      <div class="more-details-section">
        <h4>Additional Information</h4>
        <div class="details-grid">
          <div class="detail-item">
            <span class="detail-label">Question ID:</span>
            <span class="detail-value">{{ selectedCard.id }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Topic ID:</span>
            <span class="detail-value">{{ selectedCard.topicId || 'N/A' }}</span>
          </div>
          <div class="detail-item">
            <span class="detail-label">Exams:</span>
            <div class="exams-list">
              <span class="exam-tag" *ngIf="selectedCard.yearIAS">IAS: {{ selectedCard.yearIAS }}</span>
              <span class="exam-tag" *ngIf="selectedCard.yearUPPSC">UPPSC: {{ selectedCard.yearUPPSC }}</span>
              <span class="exam-tag" *ngIf="selectedCard.yearBPSC">BPSC: {{ selectedCard.yearBPSC }}</span>
              <span class="exam-tag" *ngIf="selectedCard.yearMPPSC">MPPSC: {{ selectedCard.yearMPPSC }}</span>
              <span class="exam-tag" *ngIf="selectedCard.yearRPSC">RPSC: {{ selectedCard.yearRPSC }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="tab-content" *ngIf="selectedTabIndex === 2">
      <!-- Web Search tab content -->
      <div class="web-search-section">
        <h4>Web Search</h4>
        <p>Web search functionality will be available soon.</p>
        <div class="search-placeholder">
          <p>Search the web for additional information related to this question.</p>
        </div>
      </div>
    </div>
  </div>
  <mat-toolbar class="pane-footer">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="center" class="footer-tabs"
                  [(selectedIndex)]="selectedTabIndex"
                  (selectedIndexChange)="onTabChange($event)">
      <mat-tab label="Details"></mat-tab>
      <mat-tab label="More-Details"></mat-tab>
      <mat-tab label="Web Search"></mat-tab>
    </mat-tab-group>
  </mat-toolbar>
</div>
